import { Typography, styled } from '@mui/material';
import { DefaultProps } from '../../common/types';
import { MessageErrorIcon } from '../../theme/icons';
import { theme } from '../../theme';

export interface ErrorPanelProps extends DefaultProps {
    title?: string;
    message?: string;
}

function ErrorPanelComponent(props: ErrorPanelProps) {
    const { title = 'Please review the following error', message } = props;

    if (!message) {
        return null;
    }

    return (
        <div className={props.className}>
            <div className="header">
                <MessageErrorIcon className={'icon'} />
                <div className="content">
                    <Typography className="title" variant="body1">
                        {title}
                    </Typography>
                    <Typography className="message" variant="body2" color={theme.app.neutralColor.textMain}>
                        {message}
                    </Typography>
                </div>
            </div>
        </div>
    );
}

export const ErrorPanel = styled(ErrorPanelComponent, { name: 'ErrorPanel' })(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 8,
    margin: theme.spacing(6, 0, 0),
    padding: theme.spacing(4),
    width: '65%',
    border: `1px solid ${theme.app.statusColor.errorLight}`,
    background: theme.app.statusColor.errorSuperLight,
    '.header': {
        display: 'flex',
        alignItems: 'flex-start',
        columnGap: theme.spacing(3),
    },
    '.icon': {
        color: theme.app.statusColor.errorMain,
        marginTop: 3,
    },
    '.title': {
        color: theme.app.statusColor.errorMain,
        fontSize: 14,
    },
    '.content': {
        width: '100%',
    },
    '.message': {
        marginTop: theme.spacing(3),
        whiteSpace: 'pre-line',
    },
}));
